import wixFullstoryLoader from '@wix/wix-fullstory-loader';

export function initFullstory() {
  wixFullstoryLoader({
    label: 'marketing-template-viewer',
  });
}
